import { ALL_APPS, ALL_VIEW_IDS, ALL_VIEWS } from 'constants/appConstants';
import PermissionsRouteWrapper from 'views/pages/components/PermissionsRouteWrapper';
import Loadable from 'ui-component/Loadable';
import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import FullHeightMainCardWrapper from 'layout/MainLayout/FullHeightMainCardWrapper';

const Rfqs = Loadable(lazy(() => import('views/sourcing/Rfqs')));
const Rfq = Loadable(lazy(() => import('views/sourcing/Rfq')));
const Quotes = Loadable(lazy(() => import('views/sourcing/Quotes')));
const Quote = Loadable(lazy(() => import('views/sourcing/Quote')));
const SupplierSearch = Loadable(
  lazy(() => import('views/sourcing/SupplierSearch'))
);
const SourcingDashboard = Loadable(
  lazy(() => import('views/sourcing/SourcingDashboard'))
);
const SourcingRfqs = Loadable(
  lazy(() => import('views/simplifiedPurchasing/Rfqs'))
);
const SourcingRfq = Loadable(
  lazy(() => import('views/simplifiedPurchasing/Rfq'))
);

export const SourcingRoutes = [
  {
    path: `${ALL_APPS.SOURCING.path}`,
    element: (
      <PermissionsRouteWrapper permissionScope={{ app: ALL_APPS.SOURCING.id }}>
        <Navigate to={ALL_VIEWS.SOURCING_DASHBOARD.path ?? ''} replace />
      </PermissionsRouteWrapper>
    ),
  },
  {
    path: `${ALL_VIEWS.SOURCING_DASHBOARD.path}`,
    element: (
      <PermissionsRouteWrapper
        permissionScope={{
          app: ALL_APPS.SOURCING.id,
        }}
      >
        <SourcingDashboard />
      </PermissionsRouteWrapper>
    ),
  },
  {
    path: `${ALL_VIEWS.RFQ.path}`,
    element: (
      <FullHeightMainCardWrapper>
        <PermissionsRouteWrapper
          permissionScope={{
            app: ALL_APPS.SOURCING.id,
            view: ALL_VIEW_IDS.RFQ,
          }}
        >
          <Rfqs />
        </PermissionsRouteWrapper>
      </FullHeightMainCardWrapper>
    ),
  },
  {
    path: `${ALL_VIEWS.RFQ.path}/:rfqId`,
    element: (
      <PermissionsRouteWrapper
        permissionScope={{
          app: ALL_APPS.SOURCING.id,
          view: ALL_VIEW_IDS.RFQ,
        }}
      >
        <Rfq />
      </PermissionsRouteWrapper>
    ),
  },
  {
    path: `${ALL_VIEWS.QUOTE.path}`,
    element: (
      <FullHeightMainCardWrapper>
        <PermissionsRouteWrapper
          permissionScope={{
            app: ALL_APPS.SOURCING.id,
          }}
        >
          <Quotes />
        </PermissionsRouteWrapper>
      </FullHeightMainCardWrapper>
    ),
  },
  {
    path: `${ALL_VIEWS.QUOTE.path}/:quoteId`,
    element: (
      <PermissionsRouteWrapper
        permissionScope={{
          app: ALL_APPS.SOURCING.id,
        }}
      >
        <Quote />
      </PermissionsRouteWrapper>
    ),
  },
  {
    path: `${ALL_VIEWS.SUPPLIER_SEARCH.path}`,
    element: (
      <FullHeightMainCardWrapper>
        <PermissionsRouteWrapper
          permissionScope={{
            app: ALL_APPS.SOURCING.id,
            view: ALL_VIEW_IDS.SUPPLIER_SEARCH,
          }}
        >
          <SupplierSearch />
        </PermissionsRouteWrapper>
      </FullHeightMainCardWrapper>
    ),
  },
  {
    path: `${ALL_VIEWS.SOURCING_RFQS.path}`,
    element: (
      <FullHeightMainCardWrapper>
        <PermissionsRouteWrapper
          permissionScope={{ app: ALL_APPS.SOURCING.id }}
        >
          <SourcingRfqs />
        </PermissionsRouteWrapper>
      </FullHeightMainCardWrapper>
    ),
  },
  {
    path: `${ALL_VIEWS.SOURCING_RFQS.path}/:purchaseRequestGroupId`,
    element: (
      <PermissionsRouteWrapper permissionScope={{ app: ALL_APPS.SOURCING.id }}>
        <SourcingRfq />
      </PermissionsRouteWrapper>
    ),
  },
];
